import api from './api';

const projectsService = {
  async getAll(page = 1, limit = 10, categoryId = null) {
    const params = { page, limit };
    if (categoryId) params.categoryId = categoryId;
    const response = await api.get('/projects', { params });
    return response.data;
  },

  async getOne(id) {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await api.post('/projects', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.patch(`/projects/${id}`, data);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/projects/${id}`);
    return response.data;
  },
};

export default projectsService;
